<template>
  <div class="lg-tela">

    <!-- Painel da marca -->
    <section class="lg-marca">
        <span class="lg-orbe lg-orbe--1"></span>
        <span class="lg-orbe lg-orbe--2"></span>
        <span class="lg-orbe lg-orbe--3"></span>

        <div class="lg-marca__conteudo">
            <img class="lg-marca__logo" src="/imagens/Logo_educonnect_crm.png" alt="EduConnect CRM">

            <div class="lg-marca__texto">
                <h2>Captação e matrículas <span>conectadas</span> ao seu ERP.</h2>
                <p>Acompanhe inscrições, processos seletivos e resultados de cada unidade em um só lugar.</p>

                <ul class="lg-recursos">
                    <li><span><i class="fa-solid fa-chart-line"></i></span>Dashboard de captação em tempo real</li>
                    <li><span><i class="fa-solid fa-arrows-rotate"></i></span>Integração automática com o Educacional ERP</li>
                    <li><span><i class="fa-solid fa-shield-halved"></i></span>Acesso seguro e segmentado por unidade</li>
                </ul>
            </div>

            <div class="lg-marca__rodape">
                <span>Uma solução</span>
                <img src="/imagens/Logo_Educacional_ERP_cab.png" alt="Educacional ERP">
            </div>
        </div>
    </section>

    <!-- Formulário -->
    <section class="lg-acesso">
        <div class="lg-cartao">
            <span class="lg-selo"><i class="fa-solid fa-lock"></i> Área restrita</span>
            <h1>Bem-vindo de volta</h1>
            <p class="lg-subtitulo">Entre com suas credenciais para acessar o painel.</p>

            <div class="lg-alerta" role="alert" v-if="erros.email">
                <i class="fa-solid fa-circle-exclamation"></i>
                <span>{{ (erros.email[0]=='These credentials do not match our records.' ? 'Essas credenciais não correspondem aos nossos registros.': erros.email[0]) }}</span>
            </div>

            <form method="POST" action="" @submit.prevent="login($event)">
                <input type="hidden" :value="csrf_token" name="_token"/>

                <div class="lg-campo">
                    <label for="email">E-mail</label>
                    <div class="lg-campo__entrada">
                        <i class="fa-regular fa-envelope lg-campo__icone"></i>
                        <input id="email" type="email" name="email" placeholder="seu@email.com.br" required autocomplete="email" v-model="email" autofocus>
                    </div>
                </div>

                <div class="lg-campo">
                    <label for="password">Senha</label>
                    <div class="lg-campo__entrada">
                        <i class="fa-solid fa-key lg-campo__icone"></i>
                        <input id="password" :type="showPassword" name="password" placeholder="••••••••" required autocomplete="current-password" v-model="password">
                        <button type="button" class="lg-olho" @click.prevent="mostrarSenha()" :aria-label="showPassword=='password' ? 'Mostrar senha' : 'Ocultar senha'">
                            <i :class="showPassword=='password' ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'"></i>
                        </button>
                    </div>
                </div>

                <div class="lg-opcoes">
                    <label class="lg-lembrar" for="remember">
                        <input type="checkbox" name="remember" id="remember">
                        <span>Lembrar senha</span>
                    </label>
                    <a :href="linkEsqueceuSenha">Esqueceu sua senha?</a>
                </div>

                <button type="submit" class="lg-entrar" :disabled="enviando">
                    <template v-if="enviando">
                        <span class="lg-giro"></span> Entrando...
                    </template>
                    <template v-else>
                        Entrar <i class="fa-solid fa-arrow-right"></i>
                    </template>
                </button>
            </form>

            <div class="lg-seguro">
                <i class="fa-solid fa-shield-halved"></i> Conexão segura e criptografada
            </div>
        </div>

        <footer class="lg-copyright">&copy; {{ ano }} EduConnect CRM &middot; Educacional ERP</footer>
    </section>

    <loading :id="'LoginUsuario'" titulo="Efetivando Logon do usuário, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
  </div>
</template>

<script>
export default {
    props:['linkEsqueceuSenha','csrf_token','erros'],
    data(){
        return {
            message:'',
            email:'',
            password:'',
            showPassword:'password',
            enviando:false,
            ano:new Date().getFullYear()
        }
    },
    methods:{
        mostrarSenha(){
            if(this.showPassword=='password'){
                this.showPassword='text'
            }else{
                this.showPassword='password'
            }
        },
        login(e){
            this.enviando = true
            $('#LoginUsuario').modal('show');
            let url='/api/login'
            let configuracao = {
                method:'post',
                body:new URLSearchParams({
                    'email':this.email,
                    'password':this.password
                })
            }

            fetch(url, configuracao)
                .then(response => response.json())
                .then(data =>{
                    if(data.access_token){
                        document.cookie='token='+data.access_token
                    }else{
                        console.log(data);
                    }

                })
                .catch(erro =>{
                    console.log(erro)
                    $('#LoginUsuario').modal('hide');
                })

                setTimeout(() => {
                    e.target.submit()
                }, 3000);
        }
    }
}
</script>

<style scoped>
    /* cores: tokens de resources/sass/_variables.scss */
    .lg-tela{
        display: grid;
        grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
        min-height: 100vh;
        font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    }

    /* ---------------- Painel da marca ---------------- */
    .lg-marca{
        position: relative;
        overflow: hidden;
        color: #fff;
        background:
            radial-gradient(90% 70% at 10% 0%, rgba(26, 117, 128, .55) 0%, transparent 60%),
            radial-gradient(70% 60% at 100% 100%, rgba(85, 250, 250, .14) 0%, transparent 60%),
            linear-gradient(160deg, #1c4d5a 0%, #133841 50%, #0a2026 100%);
    }

    /* grade tecnológica sutil */
    .lg-marca::before{
        content: '';
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(rgba(255,255,255,.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,.05) 1px, transparent 1px);
        background-size: 44px 44px;
        -webkit-mask-image: radial-gradient(ellipse at 30% 40%, #000 0%, transparent 75%);
                mask-image: radial-gradient(ellipse at 30% 40%, #000 0%, transparent 75%);
    }

    .lg-orbe{
        position: absolute;
        border-radius: 50%;
        filter: blur(60px);
        opacity: .55;
        animation: lg-flutuar 14s ease-in-out infinite alternate;
    }
    .lg-orbe--1{ width: 340px; height: 340px; background: #1a7580; top: -80px; right: -60px; }
    .lg-orbe--2{ width: 260px; height: 260px; background: #55fafa; opacity: .18; bottom: 8%; left: -70px; animation-duration: 18s; }
    .lg-orbe--3{ width: 180px; height: 180px; background: #2e9e8f; opacity: .35; top: 45%; right: 18%; animation-duration: 11s; }

    .lg-marca__conteudo{
        position: relative;
        z-index: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 3.25rem 4rem;
        max-width: 680px;
    }

    .lg-marca__logo{ width: 230px; height: auto; animation: lg-surgir .8s ease both; }

    .lg-marca__texto{ animation: lg-surgir .8s .15s ease both; }

    .lg-marca__texto h2{
        color: #fff;
        font-size: clamp(2rem, 3.2vw, 3rem);
        font-weight: 800;
        line-height: 1.12;
        letter-spacing: -.03em;
        margin-bottom: 1.1rem;
    }
    .lg-marca__texto h2 span{
        background: linear-gradient(90deg, #55fafa, #7fe3d0);
        -webkit-background-clip: text;
                background-clip: text;
        color: transparent;
    }
    .lg-marca__texto p{
        font-size: 1.05rem;
        color: rgba(255,255,255,.72);
        max-width: 470px;
        margin-bottom: 2.25rem;
    }

    .lg-recursos{ list-style: none; padding: 0; margin: 0; display: grid; gap: .9rem; }
    .lg-recursos li{
        display: flex;
        align-items: center;
        gap: .9rem;
        font-weight: 500;
        color: rgba(255,255,255,.88);
    }
    .lg-recursos li span{
        flex: 0 0 auto;
        width: 40px;
        height: 40px;
        display: grid;
        place-items: center;
        border-radius: 12px;
        color: #55fafa;
        background: rgba(255,255,255,.07);
        border: 1px solid rgba(85,250,250,.22);
        -webkit-backdrop-filter: blur(6px);
                backdrop-filter: blur(6px);
    }

    .lg-marca__rodape{
        display: flex;
        align-items: center;
        gap: .75rem;
        font-size: .8rem;
        color: rgba(255,255,255,.55);
        animation: lg-surgir .8s .3s ease both;
    }
    .lg-marca__rodape img{ height: 34px; width: auto; }

    /* ---------------- Formulário ---------------- */
    .lg-acesso{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3rem 1.5rem 1.5rem;
        background:
            radial-gradient(60% 50% at 100% 0%, rgba(26,117,128,.10) 0%, transparent 70%),
            #f3f6f8;
    }

    .lg-cartao{
        width: 100%;
        max-width: 440px;
        margin: auto 0;
        padding: 2.75rem 2.5rem 2.25rem;
        background: #fff;
        border: 1px solid #e3e9ed;
        border-radius: 22px;
        box-shadow: 0 30px 60px -20px rgba(14, 42, 49, .25), 0 8px 20px -10px rgba(14, 42, 49, .12);
        animation: lg-surgir .7s .1s ease both;
    }

    .lg-selo{
        display: inline-flex;
        align-items: center;
        gap: .45rem;
        padding: .3rem .75rem;
        font-size: .72rem;
        font-weight: 700;
        letter-spacing: .06em;
        text-transform: uppercase;
        color: #1a7580;
        background: rgba(26,117,128,.09);
        border-radius: 999px;
        margin-bottom: 1.1rem;
    }

    .lg-cartao h1{
        font-size: 1.85rem;
        font-weight: 800;
        letter-spacing: -.025em;
        color: #1f2d33;
        margin-bottom: .35rem;
    }
    .lg-subtitulo{ color: #64767c; margin-bottom: 1.75rem; }

    .lg-alerta{
        display: flex;
        gap: .6rem;
        align-items: flex-start;
        padding: .8rem 1rem;
        margin-bottom: 1.25rem;
        font-size: .85rem;
        font-weight: 600;
        color: #9b2c2c;
        background: #fdecec;
        border: 1px solid #f6c9c9;
        border-radius: 12px;
    }
    .lg-alerta i{ margin-top: .15rem; }

    .lg-campo{ margin-bottom: 1.15rem; }
    .lg-campo label{
        display: block;
        font-size: .82rem;
        font-weight: 600;
        color: #1f2d33;
        margin-bottom: .45rem;
    }
    .lg-campo__entrada{ position: relative; }
    .lg-campo__icone{
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: #8fa1a7;
        pointer-events: none;
        transition: color .2s;
    }
    .lg-campo__entrada input{
        width: 100%;
        height: 52px;
        padding: 0 3rem 0 2.75rem;
        font-size: .95rem;
        color: #1f2d33;
        background: #f7f9fa;
        border: 1.5px solid #e3e9ed;
        border-radius: 14px;
        outline: none;
        transition: border-color .2s, box-shadow .2s, background .2s;
    }
    .lg-campo__entrada input::placeholder{ color: #a9b7bc; }
    .lg-campo__entrada input:focus{
        background: #fff;
        border-color: #1a7580;
        box-shadow: 0 0 0 4px rgba(26,117,128,.14);
    }
    .lg-campo__entrada:focus-within .lg-campo__icone{ color: #1a7580; }

    .lg-olho{
        position: absolute;
        right: .45rem;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        display: grid;
        place-items: center;
        color: #64767c;
        background: transparent !important;
        border: 0 !important;
        border-radius: 10px;
        cursor: pointer;
        transition: color .2s, background .2s;
    }
    .lg-olho:hover{ color: #1c4d5a !important; background: rgba(26,117,128,.08) !important; }

    .lg-opcoes{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin: .25rem 0 1.6rem;
        font-size: .85rem;
    }
    .lg-lembrar{
        display: inline-flex;
        align-items: center;
        gap: .5rem;
        margin: 0;
        font-weight: 500;
        color: #64767c;
        cursor: pointer;
    }
    .lg-lembrar input{ width: 16px; height: 16px; accent-color: #1a7580; cursor: pointer; }
    .lg-opcoes a{ color: #1a7580; font-weight: 600; }
    .lg-opcoes a:hover{ color: #1c4d5a; text-decoration: none; }

    .lg-entrar{
        width: 100%;
        height: 54px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: .6rem;
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: .01em;
        color: #fff;
        background: linear-gradient(135deg, #1a7580 0%, #1c4d5a 60%, #133841 100%);
        background-size: 160% 160%;
        border: 0;
        border-radius: 14px;
        box-shadow: 0 14px 28px -12px rgba(28,77,90,.65);
        cursor: pointer;
        transition: transform .15s, box-shadow .2s, background-position .4s;
    }
    .lg-entrar:hover:not(:disabled){
        color: #fff;
        background-position: 100% 100%;
        transform: translateY(-1px);
        box-shadow: 0 18px 32px -12px rgba(28,77,90,.75);
    }
    .lg-entrar:hover i{ transform: translateX(3px); }
    .lg-entrar i{ transition: transform .2s; }
    .lg-entrar:active:not(:disabled){ transform: translateY(0); }
    .lg-entrar:disabled{ opacity: .85; cursor: progress; }

    .lg-giro{
        width: 18px;
        height: 18px;
        border: 2.5px solid rgba(255,255,255,.35);
        border-top-color: #fff;
        border-radius: 50%;
        animation: lg-girar .7s linear infinite;
    }

    .lg-seguro{
        margin-top: 1.5rem;
        padding-top: 1.25rem;
        border-top: 1px solid #eef2f4;
        text-align: center;
        font-size: .78rem;
        color: #8fa1a7;
    }
    .lg-seguro i{ color: #2e9e6b; margin-right: .3rem; }

    .lg-copyright{
        margin-top: 2rem;
        font-size: .75rem;
        color: #8fa1a7;
    }

    /* ---------------- Animações ---------------- */
    @keyframes lg-surgir{
        from{ opacity: 0; transform: translateY(14px); }
        to  { opacity: 1; transform: translateY(0); }
    }
    @keyframes lg-flutuar{
        from{ transform: translate(0, 0) scale(1); }
        to  { transform: translate(30px, -40px) scale(1.12); }
    }
    @keyframes lg-girar{ to{ transform: rotate(360deg); } }

    @media (prefers-reduced-motion: reduce){
        .lg-orbe, .lg-marca__logo, .lg-marca__texto, .lg-marca__rodape, .lg-cartao{ animation: none; }
    }

    /* ---------------- Responsivo ---------------- */
    @media (max-width: 991.98px){
        .lg-tela{ grid-template-columns: 1fr; }

        .lg-marca__conteudo{
            padding: 2.25rem 1.5rem 5.5rem;
            align-items: center;
            text-align: center;
            max-width: none;
        }
        .lg-marca__logo{ width: 200px; }
        .lg-marca__texto{ margin-top: 1.25rem; }
        .lg-marca__texto h2{ font-size: 1.55rem; margin-bottom: 0; }
        .lg-marca__texto p, .lg-recursos, .lg-marca__rodape{ display: none; }

        .lg-acesso{ padding: 0 16px 1.5rem; justify-content: flex-start; }
        .lg-cartao{ margin-top: -4rem; position: relative; z-index: 2; }
    }

    @media (max-width: 480px){
        .lg-cartao{ padding: 2rem 1.35rem 1.75rem; border-radius: 18px; }
        .lg-cartao h1{ font-size: 1.5rem; }
        .lg-opcoes{ flex-wrap: wrap; }
    }
</style>
